var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
export var MW_BASE_LIVE_URL = 'https://mw-sdk.tap.company/v2/checkout';
export var MW_BASE_STAGING_URL = 'https://mw-sdk.staging.tap.company/v2/checkout';
export var MW_BASE_DEV_URL = 'https://mw-sdk.dev.tap.company/v2/checkout';
export var MW_BASE_BETA_URL = 'https://mw-sdk.beta.tap.company/v2/checkout';
export var MW_BASE_SANDBOX_URL = 'https://mw-sdk.sandbox.tap.company/v2/checkout';
var httpClient = axios.create({
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});
httpClient.interceptors.request.use(function (config) {
    return config;
});
httpClient.interceptors.response.use(function (response) {
    return response;
});
export var setAxiosGlobalHeaders = function (headers) {
    httpClient.defaults.headers.common = __assign(__assign({}, httpClient.defaults.headers.common), headers);
};
export default httpClient;
